module.exports = __webpack_public_path__ + "img/pavl2.e383f55e.jpg";